import { render, staticRenderFns } from "./tabPremiacao.vue?vue&type=template&id=6ca1ef16&scoped=true"
import script from "./tabPremiacao.vue?vue&type=script&lang=js"
export * from "./tabPremiacao.vue?vue&type=script&lang=js"
import style0 from "./tabPremiacao.vue?vue&type=style&index=0&id=6ca1ef16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1ef16",
  null
  
)

export default component.exports